import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectField from '../../../../core/components/Fields/SelectField.tsx';
import FormField from '../../../../core/components/FormField.tsx';
import InstructionSections from '../knowledge/InstructionSections.tsx';

const AgentDeliveryMethodFormFields = ({ form }) => {
    const { t } = useTranslation('assistants', { keyPrefix: 'agentConfig' });

    const formErrors = form.formState.errors;

    const deliveryMethodOptions = [
        {
            label: t('form.deliveryMethodOptions.auto'),
            value: 'auto',
            description: t('form.deliveryMethodOptions.autoDescription'),
        },
        {
            label: t('form.deliveryMethodOptions.draftEmail'),
            value: 'draft_email',
            description: t('form.deliveryMethodOptions.draftEmailDescription'),
        },
        {
            label: t('form.deliveryMethodOptions.summary'),
            value: 'summary',
            description: t('form.deliveryMethodOptions.summaryDescription'),
        },
    ];

    return (
        <div className="flex flex-col gap-4">
            <Controller
                name="deliveryMethod"
                control={form.control}
                rules={{ required: t('form.deliveryMethodRequiredError') as string }}
                render={({ field }) => (
                    <FormField
                        label={t('form.deliveryMethod')}
                        error={formErrors.deliveryMethod}
                        helpText={t('form.deliveryMethodHelpText')}
                        required
                    >
                        <SelectField
                            {...field}
                            options={deliveryMethodOptions}
                            placeholder={t('form.deliveryMethodPlaceholder')}
                            renderOption={(option) => (
                                <>
                                    <span className="text-content-strong">{option.label}</span>
                                    <span className="block text-xs text-content-weak">{option.description}</span>
                                </>
                            )}
                            required
                        />
                    </FormField>
                )}
            />

            <Controller
                name="outputInstructions"
                control={form.control}
                render={({ field }) => (
                    <InstructionSections
                        label={t('form.outputInstructions')}
                        value={field.value}
                        onChange={field.onChange}
                    />
                )}
            />
        </div>
    );
};

export default AgentDeliveryMethodFormFields;
